export default {
  title: 'Rabat za umowę roczną',
  buttons: {
    edit: 'Edytuj rabat',
    save: 'Zapisz rabat',
  },
  toasts: {
    invalid_discount: 'Rabat za umowę roczną musi wynosić od {{min}}% do {{max}}%',
  },
};
